import { XCircleIcon, CheckCircleIcon, InformationCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid'
import React from 'react'

interface BaseMessageProps {
  type: 'success' | 'error' | 'info' | 'warning'
  withIcon?: boolean
  children: React.ReactNode
}

export const BaseMessage = ({
  type,
  withIcon = true,
  children,
}: BaseMessageProps) => {
  const icon = {
    success: <CheckCircleIcon data-testid="check-circle-icon" className="w-6 h-6 mr-2 text-green-500" />,
    error: <XCircleIcon data-testid="x-circle-icon" className="w-6 h-6 mr-2 text-red-500" />,
    info: <InformationCircleIcon data-testid="information-circle-icon" className="w-6 h-6 mr-2 text-blue-500" />,
    warning: <ExclamationCircleIcon data-testid="exclamation-circle-icon" className="w-6 h-6 mr-2 text-yellow-800" />,
  }

  const bgColor = {
    success: 'bg-green-50',
    error: 'bg-red-50',
    info: 'bg-blue-50',
    warning: 'bg-yellow-50',
  }

  const textColor = {
    success: 'text-green-800',
    error: 'text-red-800',
    info: 'text-blue-800',
    warning: 'text-yellow-800',
  }

  const borderColor = {
    success: 'border-green-800',
    error: 'border-red-800',
    info: 'border-blue-800',
    warning: 'border-yellow-800',
  }
  return (
    <div className={`p-4 border rounded-lg ${borderColor[type]} border-opacity-30 ${bgColor[type]}`}>
      <div className="flex items-center w-full">
        {withIcon && <div className="shrink-0">
          {icon[type]}
        </div>}
        <div className={`text-sm ${textColor[type]} flex-1`}>
          {children}
        </div>
      </div>
    </div>
  )
}
